import { render } from "./FormMaterialDamage.vue?vue&type=template&id=1d9f977c"
import script from "./FormMaterialDamage.vue?vue&type=script&lang=js"
export * from "./FormMaterialDamage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__